<template>
    <div>
        <POS />
    </div>
  
</template>

<script>

import POS from '../../components/pos/POS.vue';
import { mapGetters } from 'vuex';
export default {
    components:{
        POS
    },
    computed:{
        ...mapGetters("pos",["order", "clientId"]),
    }
    
}
</script>

<style>

</style>